export const pageDefinitions = [
  {
    key: 'overview',
    label: 'Übersicht',
    section: 'Allgemein',
    short: 'UE',
    icon: 'fi fi-rr-apps',
    title: 'Board Übersicht',
    description: 'Aktuelle Belegung, offene Jobs und Systemstatus in einem kompakten Dashboard.',
  },
  {
    key: 'planner',
    label: 'Planung',
    section: 'Dispo',
    short: 'TP',
    icon: 'fi fi-rr-calendar-clock',
    title: 'Dispo- und Logistikplanung',
    description: 'Tagesplanung für Tore, Fahrzeuge, Fahrer und Rentman-Jobs.',
  },
  {
    key: 'jobs',
    label: 'Jobs',
    section: 'Dispo',
    short: 'JO',
    icon: 'fi fi-rr-briefcase',
    title: 'Job Planner',
    description: 'Tagesansicht mit Jobs als Zeilen und allen zugehörigen Zuweisungen.',
  },
  {
    key: 'loadingBayPlanner',
    label: 'Ladezonen-Planung',
    section: 'Dispo',
    short: 'LP',
    icon: 'fi fi-rr-boxes',
    title: 'Loading Bay Planner',
    description: 'Tagesplanung fuer Ladezonen mit denselben Slot- und Jobwerkzeugen wie bei den Toren.',
  },
  {
    key: 'gates',
    label: 'Tore',
    section: 'Lager',
    short: 'TO',
    icon: 'fi fi-rr-grate',
    title: 'Tore verwalten',
    description: 'Tore anlegen, deaktivieren und die Display-Links für den Betrieb pflegen.',
  },
  {
    key: 'loadingBays',
    label: 'Ladezonen',
    section: 'Lager',
    short: 'LZ',
    icon: 'fi fi-rr-box-open-full',
    title: 'Ladezonen verwalten',
    description: 'Ladezonen anlegen, deaktivieren und die Display-Links fuer den Betrieb pflegen.',
  },
  {
    key: 'layoutEditor',
    label: 'Lagerlayout',
    section: 'Lager',
    short: 'LL',
    icon: 'fi fi-rr-map-location-track',
    title: 'Lagerlayout',
    description: 'Das Board-Layout für Lager und Torvisualisierung direkt im Browser bearbeiten.',
  },
  {
    key: 'displayLayout',
    label: 'Display Layout',
    section: 'Lager',
    short: 'DL',
    icon: 'fi fi-rr-layout-fluid',
    title: 'Display Layout',
    description: 'Display-Ansichten fuer Tore und Ladezonen visuell bearbeiten.',
  },
  {
    key: 'warehouseLookup',
    label: 'Lager Lookup',
    section: 'Lager',
    short: 'LU',
    icon: 'fi fi-rr-map-marker-question',
    title: 'Lager Lookup',
    description: 'Artikel über die Rentman-Daten lokalisieren und Lagerpläne zuordnen.',
  },
  {
    key: 'drivers',
    label: 'Fahrer',
    section: 'Mitarbeiter',
    short: 'FA',
    icon: 'fi fi-rr-id-badge',
    title: 'Fahrer',
    description: 'Fahrerprofile, Telefonkontakte und Führerscheine zentral verwalten.',
  },
  {
    key: 'vehicleClasses',
    label: 'Fahrzeugklassen',
    section: 'Fahrzeuge',
    short: 'FK',
    icon: 'fi fi-rr-car-side-bolt',
    title: 'Fahrzeugklassen',
    description: 'Klassen, Lizenzregeln und empfohlene Tore für den Dispo-Alltag definieren.',
  },
  {
    key: 'vehicles',
    label: 'Fahrzeuge',
    section: 'Fahrzeuge',
    short: 'FV',
    icon: 'fi fi-rr-truck-moving',
    title: 'Fahrzeuge',
    description: 'Fahrzeuge, Zuordnungen und Tagesbelegung im selben Arbeitsbereich pflegen.',
  },
  {
    key: 'license',
    label: 'Lizenz',
    section: 'Panel',
    short: 'LI',
    icon: 'fi fi-rr-shield-check',
    title: 'Lizenz und Limits',
    description: 'Freigeschaltete Module, Nutzungslimits und Instanzstatus im Blick behalten.',
  },
  {
    key: 'websiteUsers',
    label: 'Website-User',
    section: 'Panel',
    short: 'WU',
    icon: 'fi fi-rr-users-alt',
    title: 'Website-User',
    description: 'Board-Zugänge mit Rollen und Berechtigungen für das Team verwalten.',
  },
  {
    key: 'general',
    label: 'Setup',
    section: 'Panel',
    short: 'GE',
    icon: 'fi fi-rr-settings',
    title: 'Setup',
    description: 'Branding, Domain, API-Zugänge und Instanzdesign konfigurieren.',
  },
 {key:'areas',label:'Lagerflächen',section:'Ressourcen',short:'LF',icon:'fi fi-rr-box',title:'Lagerflächen',description:'Kapazitäten und Puffer verwalten.'},
];

export const sidebarSections = [
 {title:'Übersicht',pages:['overview','planner']},
 {title:'Jobs',pages:['jobs']},
 {title:'Ressourcen',pages:['gates','loadingBays','drivers','vehicles','vehicleClasses','areas']},
 {title:'Displays',pages:['displayLayout','layoutEditor','warehouseLookup']},
 {title:'Einstellungen',pages:['general','websiteUsers','license']},
];

